import { render, staticRenderFns } from "./FilesPage.vue?vue&type=template&id=747c1100&"
import script from "./FilesPage.vue?vue&type=script&lang=js&"
export * from "./FilesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports